// AWS Amplify configuration for Cognito (v6 format).
//
// Values are injected at build time from env vars populated by
// scripts/deploy.sh after `pulumi stack output`. Never commit hardcoded
// pool IDs — they differ per environment.
//
// In production builds we fail loudly when Cognito config is missing so
// that a broken deploy surfaces at build/load time instead of producing a
// silent white-screen sign-in failure. Local dev (npm start) still tolerates
// empty values — you can override on a per-branch basis.
const region = import.meta.env.VITE_COGNITO_REGION || 'af-south-1';
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
const domainPrefix = import.meta.env.VITE_COGNITO_DOMAIN || '';

if (import.meta.env.PROD && (!userPoolId || !userPoolClientId)) {
  throw new Error(
    'Missing Cognito configuration: VITE_COGNITO_USER_POOL_ID and ' +
      'VITE_COGNITO_CLIENT_ID must be set at build time. Run ' +
      '`scripts/deploy.sh` to regenerate frontend/.env.production.local ' +
      'from Pulumi stack outputs before `npm run build`.',
  );
}

const awsconfig = {
  Auth: {
    Cognito: {
      region,
      userPoolId,
      userPoolClientId,
      loginWith: domainPrefix
        ? {
            oauth: {
              domain: `${domainPrefix}.auth.${region}.amazoncognito.com`,
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [`${window.location.origin}/`],
              redirectSignOut: [`${window.location.origin}/`],
              responseType: 'code',
            },
          }
        : undefined,
    },
  },
};

export default awsconfig;
